import React from 'react';
import {motion} from 'framer-motion';
import {
    Mail,
    Download,
    Shield
} from 'lucide-react';

const Footer = ({ isTranslator = false, isTomo = false }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`${isTranslator ? 'bg-gray-900' : isTomo ? 'bg-gray-900' : 'bg-secondary-900'} text-white`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-4 gap-8">
                    {/* Brand Section */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6}}
                        viewport={{once: true}}
                        className="md:col-span-2"
                    >
                        {/* Brand section content removed but layout maintained */}
                    </motion.div>

                    {/* Quick Links */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6, delay: 0.1}}
                        viewport={{once: true}}
                    >
                        <h3 className="text-lg font-semibold mb-4">Features</h3>
                        <ul className="space-y-2">
                            {isTranslator ? (

                                <>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Smart Translation
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Voice Input
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Camera OCR
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Text-to-Speech
                                        </a>
                                    </li>
                                </>
                            ) : isTomo ? (
                                <>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Smart Creation
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Dynamic Categories
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            Real-time Search
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-gray-400 hover:text-white transition-colors duration-200">
                                            History Archive
                                        </a>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li>
                                        <a href="#features" className="text-secondary-400 hover:text-white transition-colors duration-200">
                                            Flexible Viewing
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-secondary-400 hover:text-white transition-colors duration-200">
                                            Zoom Controls
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-secondary-400 hover:text-white transition-colors duration-200">
                                            File Management
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#features" className="text-secondary-400 hover:text-white transition-colors duration-200">
                                            Theme Options
                                        </a>
                                    </li>
                                </>
                            )}
                        </ul>
                    </motion.div>

                    {/* Support */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6, delay: 0.2}}
                        viewport={{once: true}}
                    >
                        <h3 className="text-lg font-semibold mb-4">Support</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="mailto:hu477418@gmail.com" className={`${isTranslator ? 'text-gray-400' : 'text-secondary-400'} hover:text-white transition-colors duration-200 flex items-center`}>
                                    <Mail className="w-4 h-4 mr-2"/>
                                    Contact
                                </a>
                            </li>
                            <li>
                                <a href={isTranslator ? "/translator/privacy" : isTomo ? "/tomo/privacy" : "/pdf/privacy"} className={`${isTranslator || isTomo ? 'text-gray-400' : 'text-secondary-400'} hover:text-white transition-colors duration-200 flex items-center`}>
                                    <Shield className="w-4 h-4 mr-2"/>
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href={isTranslator 
                                    ? "https://play.google.com/store/apps/details?id=com.suuin.quicktranslator"
                                    : isTomo 
                                    ? "https://play.google.com/store/apps/details?id=com.obrez.daily.dolist"
                                    : "https://play.google.com/store/apps/details?id=com.palru.pdfviewer&hl=en"
                                }
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className={`${isTranslator || isTomo ? 'text-gray-400' : 'text-secondary-400'} hover:text-white transition-colors duration-200 flex items-center`}>
                                    <Download className="w-4 h-4 mr-2"/>
                                    Download
                                </a>
                            </li>
                        </ul>
                    </motion.div>
                </div>

                {/* Bottom Section */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{duration: 0.6, delay: 0.3}}
                    viewport={{once: true}}
                    className={`border-t ${isTranslator ? 'border-gray-800' : isTomo ? 'border-gray-800' : 'border-secondary-800'} mt-8 pt-8`}
                >
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className={`${isTranslator || isTomo ? 'text-gray-400' : 'text-secondary-400'} text-sm mb-4 md:mb-0`}>
                            © {currentYear} {isTranslator ? 'Quick Translator' : isTomo ? 'Tomo' : 'PDF Viewer'}. All rights reserved.
                        </div>
                        <div className={`flex items-center space-x-2 ${isTranslator || isTomo ? 'text-gray-400' : 'text-secondary-400'} text-sm`}>
                            <span>Prasadji Games Studio</span>
                        </div>
                    </div>
                </motion.div>
            </div>
        </footer>
    );
};

export default Footer; 